export default __webpack_public_path__ + "static/media/bihada-factory-mission-11.6b4e3362.jpg";